import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, AccordionDetails, AccordionSummary, SelectChangeEvent, Stack, Typography } from '@mui/material';
import { useFormik } from 'formik';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { impermeableLayerDepth, slopePD, transverseSlopeAngle } from '../../conversion/slope';
import inputRangeSlope from '../../inputRange/slope';
import { cleanImage } from '../../store/Image/imageSlice';
import { cleanAlert } from '../../store/alert/alertSlice';
import { useAppDispatch, useAppSelector } from '../../store/hook';
import { selectProject, setSlope } from '../../store/project/projectSlice';
import { cleanResult } from '../../store/result/resultSlice';
import Input from '../component/Input';
import { IInputSlope, TInputSlope } from '../iProject';
import { getInputSlope } from './util';

interface IInputSlopeProps {}

const InputSlope = (props: IInputSlopeProps) => {
    const project = useAppSelector(selectProject);
    const dispatch = useAppDispatch();

    const { t } = useTranslation();

    let timer = React.useRef<NodeJS.Timeout>();

    let input = getInputSlope(project.data?.slope!);

    const formik = useFormik<IInputSlope>({
        initialValues: input,
        onSubmit: values => {},
    });

    const handleChange = (event: React.ChangeEvent<any> | SelectChangeEvent<any>) => {
        let { name, value } = event.target;
        let valueAsNumber = parseFloat(value);
        let updateValue = { [name]: valueAsNumber };
        if (!isNaN(valueAsNumber)) {
            let payload: IInputSlope = { ...formik.values, ...updateValue };
            setValues(payload);
            dispatch(cleanResult());
            dispatch(cleanImage());
            dispatch(cleanAlert());
        }
    };

    const setValues = (payload: IInputSlope) => {
        formik.setValues(payload);
        dispatch(setSlope({ ...project.data?.slope, ...payload }));
    };

    const handleHidden = (name: string) => {
        return false;
    };

    const handleDisabled = (name: string) => {
        return false;
    };

    const handleTextTooltip = (name: string) => {
        if (name == impermeableLayerDepth) return t('impermeableLayerDepthInfobox');
        if (name == transverseSlopeAngle) return t('transverseSlopeAngleInfobox');
    };

    return (
        <Accordion disableGutters>
            <AccordionSummary variant='standard' expandIcon={<ExpandMoreIcon />} aria-controls='panel1a-content' id='panel1a-header'>
                <Typography>{t('slopeInput')}</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Stack variant='bottomLineTextGreen'>{t('slopeInputSection')}</Stack>
                {Object.keys(formik.values).map(x => (
                    <Stack key={x}>
                        <Input
                            hidden={handleHidden(x)}
                            disabled={handleDisabled(x)}
                            value={formik.values[x as TInputSlope]}
                            minValue={inputRangeSlope()[x]?.min.unitOfMeasure[project.data?.projectInfo.unitOfMeasure!]}
                            maxValue={inputRangeSlope()[x]?.max.unitOfMeasure[project.data?.projectInfo.unitOfMeasure!]}
                            id={x}
                            isNumber={typeof formik.values[x as TInputSlope] == 'number'}
                            label={t(x, { unitOfMeasure: slopePD[x as TInputSlope]?.unitOfMeasure[project.data?.projectInfo.unitOfMeasure!] })}
                            name={x}
                            onChange={handleChange}
                            textTooltip={handleTextTooltip(x as TInputSlope)}
                        />
                    </Stack>
                ))}
            </AccordionDetails>
        </Accordion>
    );
};

export default InputSlope;
